import OverrideServerPropertiesIntro from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/override-server-properties-intro.mdx";
import OverrideGeoIPPropertiesIntro from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/override-geoip-properties-intro.mdx";
import * as React from 'react';
export default {
  OverrideServerPropertiesIntro,
  OverrideGeoIPPropertiesIntro,
  React
};